import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ObtenerPrioridades } from '../../helpers/AsuntosHelper';
import { GuardarCapitulo } from '../../helpers/CapitulosHelper';
import { GuardarPrioridad } from '../../helpers/PrioridadesHelper';
import { GuardarNuevoTipoServicio } from '../../helpers/ServiciosHelper';
import { CapitulosContext } from '../../pages/catalogos/CapitulosPage';
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage';
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaCapituloComponent = () => {
    const {modalAgregaCapitulo, setModalAgregaCapitulo, obtenerCapitulos, capituloSel} = useContext(CapitulosContext);
    const [descripcion, setDescripcion] = useState();
    const [descripcionCorta, setDescripcionCorta] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [idCapitulo, setIdCapitulo] = useState(0);
    const refForm = useRef();
    console.log('Valor de modal agrega', modalAgregaCapitulo);


    const verificaAccion = () => {
      console.log('Capitulo en modal', capituloSel)
    if(capituloSel?.idCapitulo) {
        console.log('Esta editando', capituloSel);
        setIdCapitulo(capituloSel.idCapitulo);
        setDescripcion(capituloSel.descripcion);
        setDescripcionCorta(capituloSel.descripcionCorta);
      } else {
        console.log('esta agregando', capituloSel);
        setDescripcion('');
        setDescripcionCorta('');
        setIdCapitulo(0);
      }
    }

    useEffect(() => {
      verificaAccion();
    }, [capituloSel])
    

    const handleClose = () => {
        setModalAgregaCapitulo(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
       // refForm.current.isValidate();
        GuardarCapitulo(descripcion, descripcionCorta, idCapitulo).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerCapitulos();
                handleClose();

            }
        })
    }

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaCapitulo} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Capítulo</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoServicio"
            label="Capítulo"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => setDescripcion(e.target.value)}
            value={descripcion}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoServicio"
            label="Descripción corta"
            type="text"
            fullWidth
            variant="standard"
            required={false}
            onChange={(e) => setDescripcionCorta(e.target.value)}
            value={descripcionCorta}
          />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
